import { cn as e } from "../cn.js";
import { Button as t } from "../button/index.js";
import n, { createContext as r, useCallback as i, useContext as a, useMemo as o, useState as s } from "react";
import { Filter as c, Plus as l, X as u } from "lucide-react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
import { Portal as m } from "@ark-ui/react/portal";
import { When as h } from "react-if";
import { Menu as g } from "@ark-ui/react/menu";
// src/design/rigo-filters/index.tsx
var _ = r(void 0), v = () => {
	let e = a(_);
	if (!e) throw Error("RigoFilters compound components must be used within RigoFilters.Root");
	return e;
}, y = ({ children: t, visibleFilterIds: n, onVisibleFilterIdsChange: r, availableFilters: a = [], onApply: c, onFilterClear: l, className: u }) => {
	let [d, p] = s([]), m = n ?? d, h = i((e) => {
		if (m.includes(e)) return;
		let t = [...m, e];
		r ? r(t) : p(t);
	}, [m, r]), g = i((e) => {
		let t = m.filter((t) => t !== e);
		r ? r(t) : p(t);
	}, [m, r]), v = i((e) => m.includes(e), [m]), y = i(() => {
		r ? r([]) : p([]), l?.();
	}, [r, l]), b = {
		visibleFilterIds: m,
		addFilter: h,
		removeFilter: g,
		isFilterVisible: v,
		availableFilters: a,
		availableFiltersToAdd: o(() => a.filter((e) => !m.includes(e.id)), [a, m]),
		clearAllFilters: y,
		onApply: c,
		onFilterClear: l
	};
	return /* @__PURE__ */ f(_.Provider, {
		value: b,
		children: /* @__PURE__ */ f("div", {
			className: e("flex flex-col gap-3", u),
			children: t
		})
	});
}, b = ({ children: t, className: n }) => /* @__PURE__ */ f("div", {
	className: e("flex items-center gap-2 flex-wrap", n),
	children: t
}), x = ({ children: t, className: n }) => /* @__PURE__ */ f("div", {
	className: e("flex items-center gap-2 flex-wrap", n),
	children: t
}), S = () => null, C = ({ id: e, children: t }) => {
	let { isFilterVisible: r, removeFilter: i } = v();
	if (!r(e)) return null;
	let a = () => i(e);
	return typeof t == "function" ? /* @__PURE__ */ f(d, { children: t({ onRemove: a }) }) : n.isValidElement(t) ? /* @__PURE__ */ f(d, { children: n.cloneElement(t, { onRemove: a }) }) : /* @__PURE__ */ f(d, { children: t });
}, w = ({ children: n, trigger: r, className: i, showClearAll: a = !0, clearAllLabel: o = "Clear All Filters", triggerLabel: l = "Add filter" }) => {
	let { availableFiltersToAdd: u, addFilter: _, clearAllFilters: y, visibleFilterIds: b } = v(), [x, S] = s(!1), C = b.length > 0;
	return /* @__PURE__ */ p(g.Root, {
		open: x,
		onOpenChange: (e) => S(e.open),
		children: [/* @__PURE__ */ f(g.Trigger, {
			asChild: !0,
			children: r || /* @__PURE__ */ f("button", {
				type: "button",
				"aria-label": l,
				className: e("inline-flex h-8 items-center justify-center rounded-md border border-border bg-filter-bg px-3 text-sm font-medium text-foreground transition-colors hover:bg-filter-hover", x && "bg-filter-hover", i),
				children: /* @__PURE__ */ f(c, { className: "h-4 w-4" })
			})
		}), /* @__PURE__ */ f(m, { children: /* @__PURE__ */ f(g.Positioner, { children: /* @__PURE__ */ f(g.Content, {
			className: e("min-w-[220px] overflow-hidden rounded-md border border-border bg-popover shadow-floating", "animate-in fade-in-0 zoom-in-95"),
			children: n || /* @__PURE__ */ p(d, { children: [/* @__PURE__ */ f("div", {
				className: "border-b border-border px-3 py-2",
				children: /* @__PURE__ */ p("div", {
					className: "flex items-center gap-2 text-xs font-semibold text-muted-foreground",
					children: [/* @__PURE__ */ f(c, { className: "h-3.5 w-3.5" }), /* @__PURE__ */ f("span", { children: "Add Filter" })]
				})
			}), /* @__PURE__ */ p("div", {
				className: "max-h-80 overflow-y-auto p-1",
				children: [/* @__PURE__ */ p(h, {
					condition: u.length === 0,
					children: [/* @__PURE__ */ f("div", {
						className: "px-3 py-4 text-center text-sm text-muted-foreground",
						children: "All filters are active"
					}), /* @__PURE__ */ p(h, {
						condition: a && C,
						children: [/* @__PURE__ */ f(g.Separator, { className: "my-1 h-px border-t-border" }), /* @__PURE__ */ f(g.Item, {
							value: "clear-all-filters",
							asChild: !0,
							children: /* @__PURE__ */ f("div", {
								className: "px-2 py-2",
								children: /* @__PURE__ */ f(t, {
									type: "button",
									onClick: y,
									variant: "secondary",
									size: "sm",
									fullWidth: !0,
									leftIcon: "X",
									children: /* @__PURE__ */ f("span", { children: o })
								})
							})
						})]
					})]
				}), /* @__PURE__ */ p(h, {
					condition: u.length > 0,
					children: [u.map((e) => /* @__PURE__ */ f(g.Item, {
						value: e.id,
						asChild: !0,
						children: /* @__PURE__ */ p("button", {
							type: "button",
							onClick: () => {
								_(e.id), S(!1);
							},
							className: "flex w-full items-center gap-2 rounded-sm px-2 py-2 text-sm text-foreground transition-colors hover:bg-accent focus:bg-accent focus-ring-inset",
							children: [e.icon && /* @__PURE__ */ f("span", {
								className: "flex h-4 w-4 items-center justify-center text-muted-foreground",
								children: e.icon
							}), /* @__PURE__ */ f("span", {
								className: "flex-1 text-left",
								children: e.label
							})]
						})
					}, e.id)), /* @__PURE__ */ p(h, {
						condition: a && C,
						children: [/* @__PURE__ */ f(g.Separator, { className: "my-1 h-px border-t-border" }), /* @__PURE__ */ f(g.Item, {
							value: "clear-all-filters",
							className: "py-0 px-0 pt-2",
							asChild: !0,
							children: /* @__PURE__ */ f("div", {
								className: "px-2 py-2",
								children: /* @__PURE__ */ f(t, {
									type: "button",
									onClick: y,
									variant: "secondary",
									size: "sm",
									leftIcon: "X",
									fullWidth: !0,
									children: /* @__PURE__ */ f("span", { children: o })
								})
							})
						})]
					})]
				})]
			})] })
		}) }) })]
	});
}, T = ({ children: t, className: n, label: r = "Filter", showClearAll: i = !0 }) => {
	let { availableFiltersToAdd: a, visibleFilterIds: o } = v();
	return a.length === 0 || o.length === 0 ? null : /* @__PURE__ */ f(w, {
		trigger: t || /* @__PURE__ */ p("button", {
			type: "button",
			className: e("inline-flex h-8 w-fit items-center gap-2 rounded-md border border-dashed border-border bg-transparent px-3 text-sm font-medium text-muted-foreground transition-colors hover:border-filter-border hover:bg-filter-hover", n),
			children: [/* @__PURE__ */ f(l, { className: "h-4 w-4" }), /* @__PURE__ */ f("span", { children: r })]
		}),
		showClearAll: i
	});
}, E = ({ children: e, className: n, label: r = "Apply", onClick: i }) => {
	let { onApply: a } = v(), o = () => {
		i ? i() : a && a();
	};
	return e ? /* @__PURE__ */ f("div", {
		onClick: o,
		children: e
	}) : /* @__PURE__ */ f(t, {
		className: n,
		colorScheme: "primary",
		size: "sm",
		onClick: o,
		children: r
	});
}, D = ({ children: e, className: n, label: r = "Clear All" }) => {
	let { clearAllFilters: i, visibleFilterIds: a } = v();
	return a.length > 0 ? e ? /* @__PURE__ */ f("div", {
		onClick: i,
		children: e
	}) : /* @__PURE__ */ p(t, {
		type: "button",
		onClick: i,
		colorScheme: "danger",
		variant: "outline",
		size: "sm",
		className: n,
		children: [/* @__PURE__ */ f(u, { className: "mr-2 h-4 w-4" }), r]
	}) : null;
}, O = ({ staticFiltersRender: e, showApplyButton: t = !0, showFilterMenu: n = !0, applyButtonLabel: r = "Apply", ...i }) => /* @__PURE__ */ f(y, {
	...i,
	children: /* @__PURE__ */ p(b, { children: [
		e?.(),
		n && /* @__PURE__ */ f(w, {}),
		t && /* @__PURE__ */ f(E, { label: r })
	] })
}), k = () => null;
k.Default = O, k.Root = y, k.StaticRow = b, k.DynamicRow = x, k.DynamicRowItems = S, k.DynamicRowItem = C, k.FilterMenu = w, k.AddFilterButton = T, k.ApplyButton = E, k.ClearAllButton = D;
export { k as RigoFilters, v as useRigoFilters };

//# sourceMappingURL=index.js.map